module.exports = "\r\n\r\n<nav aria-label=\"Stránkování\">\r\n\r\n\t<label>Počet položek na stránce</label>\r\n\t<ul class=\"pagination\">\r\n\t\t<li class=\"page-item\" \r\n\t\t\t*ngFor=\"let ps of pageSizes\"\r\n\t\t\t[class.active]=\"ps == pageSize\">\r\n\t\t\t<button class=\"page-link\" (click)=\"changePageSize(ps)\">{{ps}}</button>\r\n\t\t</li>\r\n\t</ul>\r\n</nav>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/sm-page-size.component.html
// module id = 434
// module chunks = 11